
const firebaseConfig = {
    apiKey: "AIzaSyDVcxjxGKcIDvYkN1YaReohCMRDRaylU9s",
    authDomain: "mens-store.firebaseapp.com",
    projectId: "mens-store",
    storageBucket: "mens-store.appspot.com",
    messagingSenderId: "705335258947",
    appId: "1:705335258947:web:6b3151e08980f922c049f6",
    measurementId: "G-0SFB4YD96J"
  };
  export default firebaseConfig